import { useState } from "react";
import { APIConfig } from "../../../config/APIConfig";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAdmin } from "../../../features/authAdminSlice";

const useFormLoginAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword(!showPassword);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const data = new FormData(e.currentTarget);
    const values = Object.fromEntries(data.entries());

    if (!values.username || !values.password) {
      setLoading(false);
      return toast.error("Username dan password wajib diisi!");
    }

    toast.loading("Logging in...");

    try {
      const response = await APIConfig.post("/auth/admin/login", values, {
        withCredentials: true,
      });

      toast.dismiss();
      toast.success("Login successful!");

      setTimeout(() => {
        dispatch(setAdmin(response?.data?.data));
        toast.dismiss();
        navigate("/admin/dashboard", { replace: true });
      }, 500);
    } catch (error) {
      setLoading(false);
      toast.dismiss();

      if (error.response && error.response.data.message === "unregistered") {
        return toast.error("Username tidak terdaftar!");
      } else if (
        error.response &&
        error.response.data.message === "wrong password"
      ) {
        return toast.error("Password salah!");
      } else {
        return toast.error("Login gagal");
      }
    }

    setLoading(false);
  };

  return {
    showPassword,
    loading,
    handleTogglePassword,
    handleSubmit,
  };
};

export default useFormLoginAdmin;
